export default __webpack_public_path__ + "static/media/Webhooks.2af28032.svg";